<div class="dashboard-studies dashboard-material-theme" fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
  <dashboard-loader *ngIf="loadingStudies$ | async" [title]="'Loading Studies...'"></dashboard-loader>
  <div *ngIf="(studiesLoaded$ | async) && !userStudyTypes.length" class="dashboard-studies__message">
    You do not have access to any type of study yet. If you have any questions, please contact
    <a href="mailto:dashboard-bms@utwente.nl">dashboard-bms@utwente.nl</a>
  </div>
  <div *ngIf="studiesLoaded$ | async" class="dashboard-studies__cards" fxFlex="100">
    <div
      class="dashboard-studies__cards-actions"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="space-between start"
      fxLayoutGap.lt-md="20px"
    >
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutGap="10px">
        <ng-container *ngIf="getStudies()?.length || searchStudies">
          <mat-form-field fxFlex style="width: 300px">
            <button matSuffix mat-icon-button aria-label="Search">
              <mat-icon>search</mat-icon>
            </button>
            <input
              [(ngModel)]="searchStudies"
              (ngModelChange)="filterStudies()"
              matInput
              placeholder="Search by title or researcher"
            />
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>Sort by</mat-label>
            <mat-select>
              <mat-option
                #sortOption
                *ngFor="let option of sortOptions"
                [value]="option.value"
                (click)="sort(sortOption.value)"
              >
                {{ option.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
      <div *ngIf="userStudyTypes?.length">
        <button mat-raised-button color="accent" *dashboardHasRole="Role.CREATOR" (click)="openCreateStudyDialog()">
          {{ 'Start a new study' | uppercase }}
        </button>
      </div>
    </div>
    <div
      *ngIf="(studiesLoaded$ | async) && !getStudies()?.length"
      class="dashboard-studies__message"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <div *ngIf="!searchStudies">There are no studies that you can view or edit...</div>
      <div *ngIf="searchStudies">There are no studies that match with the search key...</div>
    </div>
    <virtual-scroller
      *ngIf="getStudies()?.length || searchStudies"
      #scroll
      class="dashboard-studies__cards-body"
      [items]="getStudies()"
      [parentScroll]="scroll.window"
      (vsEnd)="fetchMore($event)"
    >
      <mat-card *ngFor="let study of scroll.viewPortItems" class="dashboard-studies__cards-body-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="5" fxFlexAlign="start">
            <div
              class="dashboard-studies__cards-body-card-circle"
              *ngIf="study?.color"
              [ngStyle]="{ background: study?.color }"
            ></div>
          </div>
          <div fxFlex="95">
            <mat-card-header>
              <mat-card-title
                *ngIf="study?.translations | dashboardTranslate: 'title':getLanguageCodeToDisplay(study) as studyTitle"
              >
                {{
                  studyTitle.length > studyTitleLengthLimit
                    ? (studyTitle | slice: 0:studyTitleLengthLimit) + '...'
                    : studyTitle
                }}
              </mat-card-title>
              <mat-card-subtitle
                *ngIf="
                  study?.translations
                    | dashboardTranslate: 'description':getLanguageCodeToDisplay(study) as studyDescription
                "
              >
                {{
                  studyDescription.length > studyDescriptionLengthLimit
                    ? (studyDescription | slice: 0:studyDescriptionLengthLimit) + '...'
                    : studyDescription
                }}
              </mat-card-subtitle>
            </mat-card-header>
            <br />
            <mat-card-content class="dashboard-studies__cards-body-card-content" fxLayout="column" fxLayoutGap="4px">
              <p>Created by: {{ study?.owner?.firstname }} {{ study?.owner?.lastname }}</p>
              <p>
                Type:
                {{ study?.type === StudyType.TIIM ? 'TIIM Study' : 'Career Compass' }}
              </p>
              <span fxFlexAlign="end" dashboardStatusBadgeColor [status]="study?.status"></span>
            </mat-card-content>
          </div>
        </div>
        <mat-divider [inset]="true"></mat-divider>
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-card-actions fxFlex fxLayoutAlign="flex-end" class="dashboard-studies__cards-body-card-actions">
            <button mat-button color="warn" *dashboardHasRole="Role.CREATOR" (click)="openDeleteStudyDialog(study)">
              DELETE
            </button>
            <button mat-button *dashboardHasRole="Role.CREATOR" (click)="duplicateStudy(study)">DUPLICATE</button>
            <button mat-button (click)="openStudyDetails(study?.id)">OPEN</button>
          </mat-card-actions>
        </div>
      </mat-card>
      <div
        *ngIf="(studiesLoaded$ | async) && getStudies().length"
        class="dashboard-studies__footer"
        fxLayout="column"
        fxLayoutAlign="center center"
      >
        <div
          class="dashboard-studies__footer-clickable"
          fxLayout="row"
          fxLayoutAlign="center center"
          (click)="openReleasesDialog()"
        >
          <ng-container *ngIf="latestRelease$ | async as latestRelease">
            {{ latestRelease }}
          </ng-container>
          <mat-icon>arrow_drop_up</mat-icon>
          Releases
        </div>
      </div>
    </virtual-scroller>
  </div>
</div>
